module.exports = __webpack_public_path__ + "static/media/banner3-mobile2-2024.b3447596.jpg";